import * as Sentry from "@sentry/remix";
import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import { StrictMode, startTransition, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";

Sentry.init({
    dsn: "https://ab09b104f1cf7cc52b7b075b1db505ce@o4505875440467968.ingest.us.sentry.io/4507210431725568",
    tracesSampleRate: 1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
    ignoreErrors: [ "NETWORK ERROR" ],
    beforeSend: (event) => {
        // If the app is running in development mode, don't send the error to Sentry
        if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
            return null
        }
        return event
    },
    integrations: [Sentry.browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches
    }), Sentry.replayIntegration()]
})

startTransition(() => {
	hydrateRoot(
		document,
		<StrictMode>
			<RemixBrowser />
		</StrictMode>,
	);
});
